import Marquee from "react-fast-marquee";

const tech = [
  "React", "Next.js", "TypeScript", "Node.js", "Python", "FastAPI",
  "MongoDB", "PostgreSQL", "Redis", "AWS", "GCP", "Docker",
  "Kubernetes", "React Native", "Swift", "Kotlin", "TensorFlow",
  "PyTorch", "LangChain", "OpenAI", "Claude", "Gemini",
];

export const TechStack = () => {
  return (
    <section
      id="tech-stack"
      data-testid="tech-stack-section"
      className="border-b-4 border-gray-900 bg-[#FBD46D]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-20">
        <div className="text-center">
          <span className="inline-block bg-white border-[3px] border-gray-900 rounded-full px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] nb-shadow-sm">
            Our Arsenal
          </span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl leading-tight">
            Built with the tools the best teams ship with.
          </h2>
        </div>
      </div>

      <div className="mt-14 border-y-4 border-gray-900 bg-gray-900 py-6 marquee-wrap">
        <Marquee speed={55} gradient={false} pauseOnHover>
          {tech.map((t, i) => (
            <span
              key={`${t}-${i}`}
              data-testid={`tech-item-${i}`}
              className="font-display text-3xl md:text-5xl text-[#FBD46D] mx-8 flex items-center"
            >
              {t}
              <span className="ml-8 w-3 h-3 rounded-full bg-[#FF477E]" />
            </span>
          ))}
        </Marquee>
      </div>

      <div className="py-6 bg-[#FF477E] border-b-4 border-gray-900 marquee-wrap">
        <Marquee speed={40} gradient={false} direction="right">
          {["SHIP FAST", "STAY FOCUSED", "AI-FIRST", "CRAFTED CODE", "REAL RESULTS"].map((t, i) => (
            <span key={i} className="font-display text-2xl md:text-4xl text-white mx-10 flex items-center">
              {t}
              <span className="ml-10 text-[#FBD46D]">★</span>
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default TechStack;
